import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaionewaycab() {



const cardData =
{
  keyword: 'Pune to Mumbai One Way Cabs',
  heading: 'Lotus Cab: Pune to Mumbai One Way Cabs',
  headingDescription: 'Lotus Cab provides professional Pune to Mumbai One Way Cabs designed for travelers who need safe, comfortable, and affordable transportation between the two major cities. Whether you are heading to Mumbai Airport, attending a corporate meeting in BKC, planning a leisure trip to Marine Drive, or traveling for medical or family purposes, our one-way cab service ensures smooth travel via the Mumbai-Pune Expressway. We operate clean AC sedans and spacious SUVs driven by experienced highway-trained chauffeurs who understand traffic flow, toll routes, and expressway safety regulations. With transparent one-way pricing, no return fare burden, flexible pickup timing, and 24/7 support, Lotus Cab guarantees a stress-free journey. From early morning departures to late-night drops, our Pune to Mumbai taxi service prioritizes punctuality, safety, and customer satisfaction at every step of the journey.',

  top: 'Top Drop Destinations in Mumbai with Lotus Cab',

  "topPlaces": [
    {
      "title": "Mumbai International Airport (T2)",
      "description": "Mumbai International Airport Terminal 2 is one of India’s busiest and most modern airports. Many travelers book Pune to Mumbai International Airport Cab services for international departures and arrivals. Timely arrival is crucial to avoid missing flights. Lotus Cab ensures smooth expressway travel, luggage assistance, and punctual drop directly at the departure gate."
    },
    {
      "title": "Bandra Kurla Complex (BKC)",
      "description": "BKC is Mumbai’s premium business district housing major banks, multinational offices, and corporate headquarters. Business travelers frequently use Pune to Mumbai Corporate Cab services for meetings and conferences. Lotus Cab provides professional drivers and comfortable executive vehicles for corporate travel."
    },
    {
      "title": "Andheri",
      "description": "Andheri is a major commercial and residential hub close to both domestic and international airports. Travelers prefer Pune to Mumbai Airport Taxi services for direct connectivity. Lotus Cab ensures efficient city entry with route planning to avoid congestion."
    },
    {
      "title": "Dadar",
      "description": "Dadar is centrally located and well connected by railway and road networks. Many passengers require drop cab services for onward train journeys. Lotus Cab ensures timely arrival with smooth coordination."
    },
    {
      "title": "Colaba",
      "description": "Colaba is a popular tourist and business area near Gateway of India and Nariman Point. Visitors traveling from Pune for leisure often book one-way cabs. Lotus Cab offers comfortable long-distance travel experience."
    },
    {
      "title": "Powai",
      "description": "Powai is known for corporate offices and residential complexes. Professionals frequently travel for work purposes. Lotus Cab ensures safe and punctual arrival for office visits."
    },
    {
      "title": "Navi Mumbai",
      "description": "Navi Mumbai is an expanding commercial zone with IT parks and business centers. Pune to Mumbai Drop Cab service is ideal for direct travel. Lotus Cab provides affordable one-way fares."
    },
    {
      "title": "Juhu",
      "description": "Juhu Beach and surrounding luxury hotels attract tourists and families. Lotus Cab offers premium and luxury cab options for comfortable travel."
    },
    {
      "title": "Lower Parel",
      "description": "Lower Parel is a commercial and lifestyle hub with offices and malls. One-way expressway taxis ensure quick connectivity from Pune."
    },
    {
      "title": "Thane",
      "description": "Thane serves as a residential and business gateway before entering Mumbai city. Lotus Cab provides flexible drop and round-trip options."
    }
  ],

  "services": [
    {
      "name": "Pune to Mumbai One Way Cabs",
      "description": "Book Pune to Mumbai One Way Cabs with Lotus Cab for smooth, affordable, and safe highway travel. Our one-way pricing ensures you only pay for the distance traveled without return charges. Vehicles are clean, air-conditioned, and driven by experienced expressway-trained drivers. Flexible pickup timings and 24/7 booking support make travel easy and convenient."
    },
    {
      "name": "Pune to Mumbai One Way Taxi",
      "description": "Reliable Pune to Mumbai One Way Taxi service offering sedan and SUV options for individuals and families. Transparent per km rates and comfortable seating ensure a relaxed journey via expressway."
    },
    {
      "name": "Pune to Mumbai Drop Cab",
      "description": "Affordable Pune to Mumbai Drop Cab service ideal for airport transfers and business meetings. Direct drop without return fare burden."
    },
    {
      "name": "Pune to Mumbai Airport Taxi",
      "description": "Timely Pune to Mumbai Airport Taxi with punctual departure scheduling and flight coordination."
    },
    {
      "name": "Affordable Pune to Mumbai Cabs",
      "description": "Budget-friendly pricing with no hidden charges for safe and economical travel."
    },
    {
      "name": "Luxury Cab Pune to Mumbai",
      "description": "Premium sedan and SUV options for executive and VIP travel between Pune and Mumbai."
    },
    {
      "name": "Pune to Mumbai Expressway Taxi",
      "description": "Safe expressway route travel with experienced drivers and highway expertise."
    },
    {
      "name": "Pune to Mumbai Sedan Cab",
      "description": "Comfortable AC sedan cab ideal for small families and business travelers."
    },
    {
      "name": "Pune to Mumbai SUV Taxi",
      "description": "Spacious SUV taxi with extra luggage capacity for group travel."
    },
    {
      "name": "Cheap One Way Cab Pune Mumbai",
      "description": "Competitive and economical one-way cab pricing for budget travelers."
    },
    {
      "name": "Pune to Mumbai Night Taxi",
      "description": "Safe and secure night travel with verified drivers and 24/7 availability."
    },
    {
      "name": "Pune to Mumbai Corporate Cab",
      "description": "Professional corporate travel solution with punctual service."
    },
    {
      "name": "Online Pune to Mumbai Cab Booking",
      "description": "Instant online booking confirmation with flexible payment options."
    },
    {
      "name": "Best Pune to Mumbai Taxi Service",
      "description": "Top-rated intercity taxi service known for reliability and customer satisfaction."
    },
    {
      "name": "Pune to Mumbai Round Trip Cab",
      "description": "Flexible round-trip packages with customizable return schedule."
    },
    {
      "name": "Pune to Mumbai Shared Cab",
      "description": "Cost-effective shared cab option for budget-conscious travelers."
    }
  ],
  "tableData": [
  ["Pune to Mumbai One Way Cabs", "Pune to Mumbai One Way Taxi"],
  ["Pune to Mumbai Drop Cab", "Pune to Mumbai Airport Taxi"],
  ["Pune to Mumbai International Airport Cab", "Affordable Pune to Mumbai Cabs"],
  ["Luxury Cab Pune to Mumbai", "Pune to Mumbai Expressway Taxi"],
  ["Pune to Mumbai Sedan Cab", "Pune to Mumbai SUV Taxi"],
  ["Cheap One Way Cab Pune Mumbai", "Pune to Mumbai Night Taxi"],
  ["Pune to Mumbai Corporate Cab", "Online Pune to Mumbai Cab Booking"],
  ["Best Pune to Mumbai Taxi Service", "Pune to Mumbai Round Trip Cab"],
  ["Pune to Mumbai Shared Cab", ""]
],


  "whychoose": [
    { "WhyChooseheading": "Transparent One-Way Pricing", "WhyChoosedescription": "Pay only for the distance you travel without hidden charges." },
    { "WhyChooseheading": "Expressway Expertise", "WhyChoosedescription": "Experienced drivers trained for Mumbai-Pune Expressway routes." },
    { "WhyChooseheading": "Clean & Maintained Vehicles", "WhyChoosedescription": "Regularly serviced AC sedans and SUVs." },
    { "WhyChooseheading": "24/7 Booking Support", "WhyChoosedescription": "Round-the-clock availability and customer support." },
    { "WhyChooseheading": "Corporate Travel Solutions", "WhyChoosedescription": "Professional service for business travelers." },
    { "WhyChooseheading": "Luxury Options Available", "WhyChoosedescription": "Premium vehicles for executive travel." },
    { "WhyChooseheading": "On-Time Airport Transfers", "WhyChoosedescription": "Punctual departure for flight schedules." },
    { "WhyChooseheading": "Safe Night Travel", "WhyChoosedescription": "Verified drivers and secure travel even at night." }
  ]
}

const faqData = [
  { question: 'Do you provide one-way cabs from Pune to Mumbai?', answer: 'Yes, we provide affordable one-way taxi service.' },
  { question: 'Is airport drop available?', answer: 'Yes, direct airport transfer service is available.' },
  { question: 'Are fares fixed?', answer: 'Yes, transparent pricing is provided before booking.' },
  { question: 'Is night travel safe?', answer: 'Yes, drivers are verified and experienced.' },
  { question: 'Do you provide SUV options?', answer: 'Yes, SUV and sedan options available.' },
  { question: 'Is shared cab available?', answer: 'Yes, shared cab option is provided.' },
  { question: 'Can I book online?', answer: 'Yes, online booking is available.' },
  { question: 'Are vehicles AC?', answer: 'Yes, all vehicles are air-conditioned.' },
  { question: 'Do you provide corporate billing?', answer: 'Yes, corporate packages available.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended.' }
];

const testimonials = [
  { id: 1, name: 'Mr. Rahul Mehta', feedback: 'Very smooth Pune to Mumbai journey via expressway. Driver was professional and car was clean.', rating: 5 },
  { id: 2, name: 'Mrs. Kavita Shah', feedback: 'Affordable one-way airport drop service. Reached on time and felt completely safe.', rating: 5 }
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai One Way Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-mumbai-one-way-cab.jpg", 
  "description": "Lotus Cab offers Pune to Mumbai one way cabs with affordable pricing and professional drivers. Book sedan, SUV, airport transfer and expressway taxi services for safe and comfortable travel from Pune to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-mumbai-one-way-cabs"
  }
};




  return (
    <div>
      


<Helmet>
  <title>Contact: +91 8767592195 | Pune to Mumbai One Way Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai one way cabs with Lotus Cab. Affordable sedan & SUV taxi via expressway, airport transfers & corporate travel. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai One Way Cabs, Pune to Mumbai One Way Taxi, Pune to Mumbai Drop Cab, Pune to Mumbai Airport Taxi, Pune to Mumbai International Airport Cab, Affordable Pune to Mumbai Cabs, Luxury Cab Pune to Mumbai, Pune to Mumbai Expressway Taxi, Pune to Mumbai Sedan Cab, Pune to Mumbai SUV Taxi, Cheap One Way Cab Pune Mumbai, Pune to Mumbai Night Taxi, Pune to Mumbai Corporate Cab, Online Pune to Mumbai Cab Booking, Best Pune to Mumbai Taxi Service, Pune to Mumbai Round Trip Cab, Pune to Mumbai Shared Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaionewaycab;